// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedGaugeMeterDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.5 3H8.5L8.99211 10.8738C8.99732 10.9151 9 10.9573 9 11 9 11.5523 8.55228 12 8 12 7.44772 12 7 11.5523 7 11 7 10.9573 7.00268 10.9151 7.00789 10.8738L7.5 3ZM6.48914 3.14258C5.21024 3.38702 4.03941 3.93595 3.055 4.71104L4.39067 6.2067C4.97324 5.76734 5.63846 5.43173 6.35885 5.22733L6.48914 3.14258ZM9.64115 5.22733 9.51086 3.14258C10.7898 3.38703 11.9607 3.936 12.9451 4.71115L11.6095 6.2068C11.0269 5.76739 10.3616 5.43174 9.64115 5.22733ZM12.3552 6.87307 13.6908 5.37744C15.1186 6.82237 16 8.80831 16 11.0001 16 11.6907 15.9125 12.3609 15.748 13.0001H13.6586C13.8797 12.3746 14 11.7014 14 11.0001 14 9.40129 13.3746 7.94852 12.3552 6.87307ZM2 11.0001C2 9.40123 2.62541 7.94841 3.64493 6.87294L2.30929 5.37731C.881485 6.82226 0 8.80825 0 11.0001 0 11.6907.087506 12.3609.252035 13.0001H2.34141C2.12031 12.3746 2 11.7014 2 11.0001Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.84058 6.36835C6.47032 5.15491 8.41857 4.34536 10.5371 4.08789L10.4525 6.11863C8.87167 6.3642 7.41331 6.98005 6.16887 7.87474L4.84058 6.36835ZM19.1592 6.3683C17.5295 5.15491 15.5813 4.3454 13.4629 4.08791L13.5475 6.11865C15.1282 6.36423 16.5865 6.98006 17.8309 7.87469L19.1592 6.3683ZM11.5 5H12.5L12.9965 16.9155C12.9988 16.9433 13 16.9715 13 17 13 17.5523 12.5523 18 12 18 11.4477 18 11 17.5523 11 17 11 16.9715 11.0012 16.9433 11.0035 16.9155L11.5 5ZM22 16.0004C22 17.0456 21.8396 18.0534 21.5422 19.0004H23.6219C23.8687 18.0416 24 17.0363 24 16.0004 24 12.776 22.7282 9.84853 20.6589 7.69238L19.3306 9.19876C20.9871 10.9833 22 13.3736 22 16.0004ZM2 16.0004C2 13.3736 3.01284 10.9833 4.66931 9.19882L3.34102 7.69245C1.27175 9.84859 0 12.776 0 16.0004 0 17.0363.131259 18.0416.378052 19.0004H2.4578C2.16035 18.0534 2 17.0456 2 16.0004Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedGaugeMeterDefault is a generated icon component.
 */
let IconMedGaugeMeterDefault = IconMedGaugeMeterDefault_1 = class IconMedGaugeMeterDefault extends IconBaseElement {
    render() {
        return html `${IconMedGaugeMeterDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedGaugeMeterDefault.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedGaugeMeterDefault = IconMedGaugeMeterDefault_1 = __decorate([
    customElement('zui-icon-med-gauge-meter-default')
], IconMedGaugeMeterDefault);
export { IconMedGaugeMeterDefault };
